import React from 'react';
import { Button } from 'react-bootstrap';
import type { ChangeCabDeckSlide } from '../../../types/changes';

type Props = {
  slides: ChangeCabDeckSlide[];
  slideIndex: number;
  canManage: boolean;
  dragSlideFrom: number | null;
  dragSlideOver: number | null;
  listRef: React.Ref<HTMLDivElement>;
  onInsert: () => void;
  onToggleActive: (index: number) => void;
  onDelete: (index: number) => void;
  onSelectSlide: (index: number) => void;
  onDragHandlePointerDown: (event: React.PointerEvent, index: number) => void;
};

const CabDeckSlideList: React.FC<Props> = ({
  slides,
  slideIndex,
  canManage,
  dragSlideFrom,
  dragSlideOver,
  listRef,
  onInsert,
  onToggleActive,
  onDelete,
  onSelectSlide,
  onDragHandlePointerDown,
}) => {
  return (
    <div className="border rounded p-2 bg-white">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <strong className="small">Slides</strong>
        {canManage ? (
          <Button size="sm" variant="outline-primary" onClick={onInsert}>
            +
          </Button>
        ) : null}
      </div>
      {canManage ? (
        <p className="small text-muted mb-2">
          Clique no título para abrir; use o ícone ⋮⋮ para arrastar e reordenar.
        </p>
      ) : null}
      <div ref={listRef} className="d-flex flex-column gap-1">
        {slides.map((slide, index) => (
          <div
            key={`s-${slide.id ?? 'n'}-${index}`}
            data-slide-index={index}
            className={[
              'border rounded p-2 cab-deck-slide-list-item',
              index === slideIndex ? 'border-primary bg-light' : '',
              slide.is_active === false ? 'is-inactive' : '',
              dragSlideFrom === index ? 'is-dragging' : '',
              dragSlideOver === index && dragSlideFrom !== index ? 'is-drag-over' : '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            <div className="d-flex align-items-start gap-1">
              {canManage ? (
                <button
                  type="button"
                  className="cab-deck-slide-drag-handle"
                  aria-label={`Reordenar slide ${index + 1}`}
                  title="Arrastar para reordenar"
                  onPointerDown={(e) => onDragHandlePointerDown(e, index)}
                >
                  ⋮⋮
                </button>
              ) : null}
              <button
                type="button"
                className="btn btn-link p-0 text-start text-dark text-decoration-none flex-grow-1 cab-deck-slide-select"
                onClick={() => onSelectSlide(index)}
              >
                <span className="fw-semibold small d-inline-flex align-items-center gap-1 flex-wrap">
                  {index + 1}. {slide.title}
                  {slide.is_active === false ? (
                    <span className="badge text-bg-secondary">Inativo</span>
                  ) : null}
                </span>
              </button>
            </div>
            {canManage ? (
              <div className="d-flex flex-wrap gap-1 mt-1">
                <Button
                  size="sm"
                  variant={slide.is_active === false ? 'outline-success' : 'outline-warning'}
                  onClick={() => onToggleActive(index)}
                >
                  {slide.is_active === false ? 'Ativar' : 'Desativar'}
                </Button>
                <Button size="sm" variant="outline-danger" onClick={() => onDelete(index)}>
                  Excluir
                </Button>
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CabDeckSlideList;
